<template>
  <div>
    <mdb-row style="">
      <mdb-col md="3" class="card-div solicitudes__card-div">
        <div class="title-style">
          Solicitudes
          <br />
          <div style="font-size: 16px; font-weight: lighter; display: -webkit-box">
            Total solicitudes:
            <span style="font-size: 18px; font-weight: 600">{{
                totalOfElements
            }}</span>
          </div>
        </div>
      </mdb-col>
      <mdb-col md="7" class="card-div solicitudes__card-div searchBar" >
        <input class="input-style" type="text" name="buscador" id="search"
          placeholder="Buscar por No. de Solicitud, Nombre(s), Apellidos y Estatus de solicitud." v-model="search"
          :disabled="statusFilter != ''" 
        />
        <mdb-card v-if="showFilterApp" class="filterStyle">
          <mdb-card-body>
            <mdb-row>
              <label for="userType" class="labelPop" style="font-size: 15px !important">Filtrado por estatus de
                solicitud:</label>
            </mdb-row>
            <mdb-row>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="todos" v-model="statusFilter" value />
                    <label for="todos" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="statusFilter == '' ? 'form__label-active' : ''"></span>Todos
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="creada" v-model="statusFilter" value="CREATED" />
                    <label for="creada" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'CREATED' ? 'form__label-active' : ''
                      "></span>Creada
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col lg="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="investigacionF" v-model="statusFilter" value="RESEARCH_FINISHED" />
                    <label for="investigacionF" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'RESEARCH_FINISHED'
                          ? 'form__label-active'
                          : ''
                      "></span>Lista para revisión
                    </label>
                  </div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row class="mt-3">
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="revision" v-model="statusFilter" value="IN_REVIEW_BY_PARTNER_SERVICE" />
                    <label for="revision" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'IN_REVIEW_BY_PARTNER_SERVICE'
                          ? 'form__label-active'
                          : ''
                      "></span>En Revisión por Atención a Socios
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="review1" v-model="statusFilter" value="IN_EDIT_BY_PARTNER_SERVICE" />
                    <label for="review1" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'IN_EDIT_BY_PARTNER_SERVICE'
                          ? 'form__label-active'
                          : ''
                      "></span>En Corrección por el Solicitante
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="comite" v-model="statusFilter" value="IN_REVIEW_BY_COMMITTEE" />
                    <label for="comite" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'IN_REVIEW_BY_COMMITTEE'
                          ? 'form__label-active'
                          : ''
                      "></span>En Revision por Comité
                    </label>
                  </div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row class="mt-3">
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="aceptada" v-model="statusFilter" value="ACCEPTED" />
                    <label for="aceptada" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'ACCEPTED' ? 'form__label-active' : ''
                      "></span>Aceptada
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="review2" v-model="statusFilter" value="IN_EDIT_ACCEPTED" />
                    <label for="review2" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'IN_EDIT_ACCEPTED'
                          ? 'form__label-active'
                          : ''
                      "></span>Aceptada pero require correcciones
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="documentFinish" v-model="statusFilter" value="DOCUMENTATION_FINISHED" />
                    <label for="documentFinish" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'DOCUMENTATION_FINISHED'
                          ? 'form__label-active'
                          : ''
                      "></span>Documentación Finalizada
                    </label>
                  </div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row class="mt-3">
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="finalizada" v-model="statusFilter" value="FINISHED" />
                    <label for="finalizada" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'FINISHED' ? 'form__label-active' : ''
                      "></span>Finalizada
                    </label>
                  </div>
                </div>
              </mdb-col>
              <mdb-col md="4">
                <div class="form__group">
                  <div class="form__check">
                    <input type="radio" id="declinada" v-model="statusFilter" value="DECLINED" />
                    <label for="declinada" style="font-size: 15px; font-weight: 600; color: #000">
                      <span :class="
                        statusFilter == 'DECLINED' ? 'form__label-active' : ''
                      "></span>Declinada
                    </label>
                  </div>
                </div>
              </mdb-col>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
      <mdb-col md="2" class="card-div solicitudes__card-div">
        <div>
          <button class="btn buttonFilter" type="button" @click="showFilterApp = !showFilterApp">
            <img src="/img/icons/InoFiltrar.svg" alt="filtrar" />
          </button>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <b-table :items="dataList" :fields="columns" class="text-center" :responsive="true" :no-provider-paging="true"
        :show-empty="true"
        emptyText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda."
        emptyFilteredText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda.">

        <template #cell(applicationNumber)="data">
          <div v-if="loginUserType != 'CLUB_ADMIN'" class="t1-checkbox">
            <input type="checkbox" :id="data.item.id" :value="{ id: data.item.id, status: data.item.applicationStatus }"
              v-model="checkedApp" />
            <label :for="data.item.id">
              <span class="check-custom"></span>
              {{ data.item.applicationNumber }}
            </label>
          </div>
          <div v-else>{{ data.item.applicationNumber }}</div>
        </template>

        <template #cell(applicationStatus)="data">
          <div :class="getStatusClass(data.item.applicationStatus)" class="text-left"></div>
          &nbsp; &nbsp; {{ getStatusLabel(data.item.applicationStatus) }} &nbsp;&nbsp;

          <div v-if="data.item.applicationStatus == 'IN_REVIEW_BY_COMMITTEE'">
            <mdb-row>
              <div v-if="loginUserType == 'COMMITTEE'">
                <mdb-popover v-if="checkVotes(data.item.committeeVotes)" trigger="hover"
                  :options="{ placement: 'right' }">
                  <span slot="body" style="font-size: 15px; font-weight: 500"><strong>Emitiste el voto para esta
                      solicitud</strong> el
                    dia:
                    <div v-for="(item2, index2) in data.item.committeeVotes" :key="index2 + 'vote'">
                      {{ item2.username == username ? item2.createdAt : "" }}
                    </div>
                  </span>
                  <img slot="reference" style="width: 20px" :id="data.item.applicationNumber"
                    src="../../../../public/img/icons/checked.svg" alt="Voto emitido" />
                </mdb-popover>
                <mdb-popover v-else trigger="hover" :options="{ placement: 'right' }">
                  <span slot="body" style="font-size: 15px; font-weight: 500"><strong>Aún no has emitido tu voto para
                      esta solicitud.</strong>
                    Selecciona la solicitud y realiza tu voto.</span>
                  <img slot="reference" :id="data.item.applicationNumber"
                    src="../../../../public/img/icons/IconAlert.svg" alt="Voto no emitido" />
                </mdb-popover>
              </div>
            </mdb-row>

            <p v-if="(loginUserType == 'PARTNER_SERVICE' || loginUserType == 'COMMITTEE')" class="committeeVotes"
              @click="$refs.viewVotes.toggleModal(); votosComite = data.item.committeeVotes;">
              {{
                  data.item.emittedVotes +
                  " de " +
                  data.item.requiredVotes +
                  " VOTOS EMITIDOS"
              }}
            </p>
          </div>

        </template>

        <template #cell(name)="data">
          {{ data.item.name }} {{ data.item.lastName }} {{ data.item.mothersLastName }}
        </template>

        <template #cell(date)="data">
          {{ data.item.createdAt.split(" ")[0] }}
        </template>


        <template #cell(options)="data">
          <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
            <span slot="tip" style="font-size: 14px">Ver Detalle</span>
            <button slot="reference" type="button" @click="getOneApplication(data.item.id, data.item.applicationStatus)"
              class="btn btn-edit" style="padding: 3px">
              <img :src="'/img/icons/InoVerPDF.svg'" alt="icon ver" />
            </button>
          </mdb-tooltip>

          <!-- <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
            <span slot="tip" style="font-size: 14px">Subir Documentos</span>
              <button
              v-if="loginUserType == 'SUPER_ADMIN' "
              slot="reference"
              type="button"
              @click="viewListDocuments(data.item.id, data.item.applicationStatus)"
              class="btn btn-edit"
              style="padding: 3px;"
            >
               <img src="/img/notes-2.png" alt="subir documentacion" />         
            </button>
          </mdb-tooltip> -->

          <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
            <span slot="tip" style="font-size: 14px">Votar ACEPTADA</span>
            <button slot="reference" v-show="
              data.item.applicationStatus == 'ACCEPTED' &&
              loginUserType == 'COMMITTEE'
            " type="button" @click="viewDictamen(data.item.id)" class="btn btn-accepted" style="padding: 0">
              <img :src="'/img/icons/BtnVtnAceptada_Normal.svg'" alt="icon ver" />
            </button>
          </mdb-tooltip>

          <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
            <span slot="tip" style="font-size: 14px">Votar DECLINADA</span>
            <button slot="reference" v-show="
              data.item.applicationStatus == 'DECLINED' &&
              loginUserType == 'COMMITTEE'
            " type="button" @click="viewDictamen(data.item.id)" class="btn btn-delete" style="padding: 0">
              <img :src="'/img/icons/BtnVtnDenegada_Nomal.svg'" alt="icon ver" />
            </button>
          </mdb-tooltip>

          <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
            <span slot="tip" style="font-size: 14px">Notas</span>
            <button slot="reference" v-show="loginUserType == 'PARTNER_SERVICE'" type="button" class="btn btn-edit"
              style="padding: 7px" @click="
                openNotes(
                  data.item.applicationNumber,
                  data.item.name,
                  data.item.lastName,
                  data.item.mothersLastName,
                  data.item.id
                )
              ">
              <img src="/img/notes-2.png" alt="notas" />
            </button>
          </mdb-tooltip>

          <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
            <span slot="tip" style="font-size: 14px">Historial estatus</span>
            <button slot="reference" v-show="loginUserType == 'PARTNER_SERVICE'" type="button" class="btn btn-edit"
              @click="openStatusHistory(data.item.id)">
              <img src="img/historial.png" alt="Historial" />
            </button>
          </mdb-tooltip>
        </template>

      </b-table>
    </mdb-row>

    <Paginator stylePaginator="full" :currentPage="page" :totalRows="totalOfElements" :perPage="perPage"
      @changePage="changePage" @changePerPage="changePerPage" />


    <div style="width:100%">
      <div style="margin-top: 20px" class="solicitudes__fix-style-button">
        <!-- <Btn v-if="loginUserType == 'PARTNER_SERVICE'" :text="'Imprimir'" icon="imprimir" :type="'primary-admin'" style="float:right;"></Btn> -->
        <Btn v-if="loginUserType == 'PARTNER_SERVICE'" :text="'Enviar recordatorio al comité para votar'" icon="enviar"
          :type="
            checkedApp.length == 1 &&
              checkedApp[0].status == 'IN_REVIEW_BY_COMMITTEE'
              ? 'primary-admin'
              : 'disabled-admin'
          " style="" @onClick="
  checkedApp.length == 1 &&
    checkedApp[0].status == 'IN_REVIEW_BY_COMMITTEE'
    ? $refs.resendToCommite.toggleModal()
    : null
"></Btn>
        <Btn v-if="loginUserType == 'PARTNER_SERVICE'" :text="'Enviar aviso a solicitante'" icon="enviar" :type="
          checkedApp.length == 1 &&
            (checkedApp[0].status == 'ACCEPTED' ||
              checkedApp[0].status == 'DECLINED')
            ? 'primary-admin'
            : 'disabled-admin'
        " style="" @onClick="
  checkedApp.length == 1 &&
    (checkedApp[0].status == 'ACCEPTED' ||
      checkedApp[0].status == 'DECLINED')
    ? $refs.sendToApp.toggleModal()
    : null
"></Btn>
        <Btn v-if="loginUserType == 'PARTNER_SERVICE'" :text="'Revisar'" icon="revisar" :type="
          checkedApp.length == 1 &&
            checkedApp[0].status == 'RESEARCH_FINISHED'
            ? 'primary-admin'
            : 'disabled-admin'
        " style="" @onClick="
  checkedApp.length == 1 &&
    checkedApp[0].status == 'RESEARCH_FINISHED'
    ? $refs.toPartner.toggleModal()
    : null
"></Btn>
        <Btn v-if="loginUserType == 'COMMITTEE'" @onClick="
          checkedApp.length == 1 &&
            checkedApp[0].status == 'IN_REVIEW_BY_COMMITTEE'
            ? $refs.decline.toggleModal()
            : null
        " :text="'Declinar'" icon="comite-declinar" :type="
  checkedApp.length == 1 &&
    checkedApp[0].status == 'IN_REVIEW_BY_COMMITTEE'
    ? 'primary-admin-decline'
    : 'disabled-admin'
" style=""></Btn>
        <Btn v-if="loginUserType == 'COMMITTEE'" @onClick="
          checkedApp.length == 1 &&
            checkedApp[0].status == 'IN_REVIEW_BY_COMMITTEE'
            ? $refs.accept.toggleModal()
            : null
        " :text="'Aceptar'" icon="comite-aceptar" :type="
  checkedApp.length == 1 &&
    checkedApp[0].status == 'IN_REVIEW_BY_COMMITTEE'
    ? 'primary-admin-accept'
    : 'disabled-admin'
" style=""></Btn>
      </div>
    </div>

    <PopupApp size="lg-extra" :title="
      'Solicitud No.: ' +
      application.application.applicationNumber +
      '       ' +
      application.name +
      ' ' +
      application.lastName +
      ' ' +
      application.mothersLastName
    " header="popup__header-admin" classTitle="popup__title-mod" ref="solicitud" :eventHub="eventHub">
      <mdb-container style="display: block; overflow: auto; max-height: 60rem">
        <App :key="application.application.applicationNumber" :eventHub="eventHub" />
      </mdb-container>
    </PopupApp>

    <PopupApp size="lg-extra" :title="
      'Solicitud No.: ' +
      application.application.applicationNumber +
      '       ' +
      application.name +
      ' ' +
      application.lastName +
      ' ' +
      application.mothersLastName
    " header="popup__header-admin" classTitle="popup__title-mod" ref="uploadDocumentation" :eventHub="eventHub">
      <mdb-container style="display: block; overflow: auto; max-height: 60rem">
        <AppUp :key="application.application.applicationNumber" :eventHub="eventHub" />
      </mdb-container>
    </PopupApp>

    <PopupApp size="lg-extra" :title="
      'Solicitud No.: ' +
      application.application.applicationNumber +
      '       ' +
      application.name +
      ' ' +
      application.lastName +
      ' ' +
      application.mothersLastName
    " header="popup__header-admin" classTitle="popup__title-mod" ref="solicitudCreada" :eventHub="eventHub">
      <div class="documents-section">
        <div class="accordion-section">
          <div style="font-size: 18px; font-weight: 600">
            <span>
              Fecha de generación de Solicitud:
              {{ application.application.createdAt.split(" ")[0] }}
            </span>
          </div>
          <!--TITULAR-->
          <Accordion title="Titular" id="titular" :key="'titular'" :eventHub="eventHub">
            <div class="accordion-header">Datos del solicitante</div>
            <div class="accordion-content p-3">
              <mdb-row>
                <mdb-col md="12">
                  <mdb-row class="mt-3">
                    <mdb-col v-if="application.name" md="4">
                      <label for="input_name" class="form__label">Nombre:</label>
                      <input type="text" id="input_name" class="form__input" v-model="application.name" disabled />
                    </mdb-col>
                    <mdb-col v-if="application.lastName" md="4">
                      <label for="input_lastname" class="form__label">Apellido parterno:</label>
                      <input type="text" id="input_lastname" class="form__input" v-model="application.lastName"
                        disabled />
                    </mdb-col>
                    <mdb-col v-if="application.mothersLastName" md="4">
                      <label for="input_Mlastname" class="form__label">Apellido materno:</label>
                      <input type="text" id="input_Mlastname" class="form__input" v-model="application.mothersLastName"
                        disabled />
                    </mdb-col>
                  </mdb-row>
                  <mdb-row class="mt-3">
                    <mdb-col md="8">
                      <label for="input_email" class="form__label">Correo electrónico:</label>
                      <input type="text" id="input_email" class="form__input" v-model="application.user.username"
                        disabled />
                    </mdb-col>
                  </mdb-row>
                  <mdb-row v-if="application.phones.length > 0" class="mt-3">
                    <mdb-col md="8">
                      <label for="input_email" class="form__label">Teléfono personal:</label>
                      <input type="text" id="input_email" class="form__input"
                        v-model="application.phones[0].phoneNumber" disabled />
                    </mdb-col>
                  </mdb-row>
                  <mdb-row class="mt-3">
                    <mdb-col md="8">
                      <label for="input_motivo" class="form__label">Motivo por el que no ha continuado su
                        trámite:</label>
                      <div v-if="application.application.payment">
                        <input v-if="
                          application.application.payment.paymentStatus ==
                          'APPROVED'
                        " type="text" id="input_motivo" class="form__input"
                          value="Pendiente de registro de datos de cónyuge." disabled />
                        <input v-else-if="
                          application.application.payment.paymentStatus ==
                          'REJECTED'
                        " type="text" id="input_motivo" class="form__input"
                          value="El pago no fue aprobado. Sigue pendiente de realizar nuevamente el pago" disabled />
                        <input v-else type="text" id="input_motivo" class="form__input"
                          value="Pendiente de realizar pago por trámite de admisión." disabled />
                      </div>

                      <input v-else type="text" id="input_motivo" class="form__input"
                        value="Pendiente de realizar pago por trámite de admisión." disabled />
                    </mdb-col>
                  </mdb-row>
                </mdb-col>
              </mdb-row>
            </div>
          </Accordion>
        </div>
      </div>
    </PopupApp>

    <Popup size="sm" ref="toPartner">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="
                  font-size: 19px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  text-align: center;
                  color: #dc7134;
                ">
                ¿ESTÁS SEGUR@ DE COLOCAR EL ESTATUS DE LA SOLICITUD EN REVISIÓN?
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div style="
                  font-size: 17px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #4f4f4f;
                  text-align: center;
                  padding: 0rem 2rem;
                ">
                La solicitud se colocará en estatus en Revisión, una vez
                colocado este estatus no se podrá modificar.
              </div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%">
                <Btn @onClick="sendToRevision" :text="'Aceptar'" :type="'primary-admin'" style="float: right"></Btn>
                <Btn @onClick="$refs.toPartner.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"
                  style="float: right; margin-right: 1rem"></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup size="sm-mod2" ref="notes">
      <div class="text-center">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="font-size: 15px; font-weight: 600; color: #000">
                NOTAS DE LA SOLICITUD: {{ notesTitle }}
              </div>
            </mdb-row>
            <mdb-row class="mt-3">
              <textarea class="form-control" rows="25" maxlength="3000" v-model="notesApp" style="
                  font-size: 20px;
                  font-weight: 600;
                  color: #000;
                  border-radius: 1px;
                " @keypress="maxCharCount">
              </textarea>
              <span>{{ notesApp.length }} / 3000</span>
            </mdb-row>
            <mdb-row class="mt-3">
              <mdb-col md="7"></mdb-col>
              <mdb-col md="5">
                <Btn :text="'GUARDAR NOTAS'" :type="'primary-admin'" style="float: right; width: 105%"
                  @onClick="closeNotes()"></Btn>
              </mdb-col>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup size="xs" ref="accept">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="
                  font-size: 19px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  text-align: center;
                  color: #dc7134;
                ">
                ¿Deseas
                <strong>ACEPTAR</strong> la solicitud de admisión generada?
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div style="
                  font-size: 15px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #4f4f4f;
                  text-align: center;
                  padding: 0rem 2rem;
                ">
                Una vez que aceptas no podrás cambiar el dictamen.
              </div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%">
                <Btn @onClick="$refs.accept.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"
                  style="float: left; margin-right: 1rem"></Btn>
                <Btn @onClick="vote('ACCEPTED')" :text="'Aceptar'" :type="'primary-admin-accept'" style="float: right">
                </Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup size="xs" ref="decline">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="
                  font-size: 19px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  text-align: center;
                  color: #dc7134;
                ">
                ¿Deseas
                <strong>DECLINAR</strong> la solcitud de admisión generada?
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div style="
                  font-size: 15px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #4f4f4f;
                  text-align: center;
                  padding: 0rem 2rem;
                ">
                Una vez que declinas no podrás cambiar el dictamen.
              </div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%">
                <Btn @onClick="$refs.decline.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"
                  style="float: left; margin-right: 1rem"></Btn>
                <Btn @onClick="vote('DECLINED')" :text="'declinar'" :type="'primary-admin-decline'"
                  style="float: right"></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup size="sm" ref="dictamen">
      <div class="text-center">
        <mdb-row>
          <mdb-col md="12">
            <mdb-row style="padding-left: 10%">
              <span style="
                  text-align: center;
                  font-size: 21px;
                  font-weight: 600;
                  color: #dc7134;
                ">RESULTADO DE DICTAMEN DE LA SOLICITUD</span>
              <p style="font-size: 14px; color: #4f4f4f">
                De un total de {{ votesDone + votesDeclined }} participantes del
                Comité, se obtuvieron los siguientes resultados:
              </p>
            </mdb-row>

            <div style="
                width: 650px;
                padding: 3rem 10rem;
                border-radius: 5px;
                border: solid 1px #828282;
              ">
              <mdb-row>
                <mdb-col md="5" style="margin-left: 3rem">
                  <mdb-row>
                    <span style="font-size: 21px; font-weight: 600; color: #3a8a65">ACEPTADOS</span>
                  </mdb-row>
                  <mdb-row class="mt-3">
                    <img src="/img/icons/InoVotosAceptados.svg" />
                  </mdb-row>
                  <mdb-row>
                    <span style="font-size: 21px; font-weight: 600; color: #3a8a65">{{ votesDone }} VOTO(S)</span>
                  </mdb-row>
                </mdb-col>
                <mdb-col md="5" style="margin-left: 3rem">
                  <mdb-row>
                    <span style="font-size: 21px; font-weight: 600; color: #eb5757">DECLINADOS</span>
                  </mdb-row>
                  <mdb-row class="mt-3">
                    <img src="/img/icons/InoVotosDenegados.svg" />
                  </mdb-row>
                  <mdb-row>
                    <span style="font-size: 21px; font-weight: 600; color: #eb5757">{{ votesDeclined }} VOTO(S)</span>
                  </mdb-row>
                </mdb-col>
              </mdb-row>
              <mdb-row style="margin-top: 5rem; width: 650px; margin-left: -10rem">
                <div class="divLine"></div>
              </mdb-row>
              <mdb-row style="margin-top: 3rem">
                <mdb-col md="12">
                  <span style="font-size: 16px; color: #4f4f4f">
                    Por lo tanto la solicitud es :
                    <span :style="
                      statusFinal == 'ACEPTADA'
                        ? ' font-size: 17px; font-weight: 600; color: #3a8a65;'
                        : ' font-size: 17px; font-weight: 600; color: #eb5757;'
                    ">{{ statusFinal }}</span>
                  </span>
                </mdb-col>
              </mdb-row>
            </div>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Popup size="sm" ref="sendToApp">
      <div class="text-center">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="
                  font-size: 19px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  text-align: center;
                  color: #dc7134;
                ">
                ENVIAR RESPUESTA AL SOLICITANTE
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div style="font-size: 14px; color: #4f4f4f; text-align: center">
                Se enviará un correo al solicitante de
                <strong>SOLICITUD {{ appStatus }}</strong>.
              </div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%">
                <Btn @onClick="sendEmail" :text="'Enviar'" :type="'primary-admin'" style="float: right"></Btn>
                <Btn @onClick="$refs.sendToApp.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"
                  style="float: right; margin-right: 1rem"></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
    <Popup size="sm" ref="resendToCommite">
      <div class="text-center">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div style="
                  font-size: 19px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  text-align: center;
                  color: #dc7134;
                ">
                ENVIAR CORREO DE RECORDATORIO
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div style="
                  font-size: 18px;
                  color: #4f4f4f;
                  text-align: center;
                  font-weight: 500;
                ">
                Se enviará un correo de recordatorio
                <strong>solo para aquellos usuarios del Comité que aún no han
                  realizado su voto</strong>
                para esta solicitud que has seleccionado
              </div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%">
                <Btn @onClick="resendToCommite" :text="'Enviar recordatorio'" :type="'primary-admin'"
                  style="float: right"></Btn>
                <Btn @onClick="$refs.resendToCommite.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"
                  style="float: right; margin-right: 1rem"></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
    <Popup size="md-mod3" ref="viewVotes">
      <div class="text-center">
        <mdb-col md="12">
          <mdb-row class="mb-3">
            <span style="
                text-align: center;
                font-size: 21px;
                font-weight: 600;
                color: #dc7134;
                padding-left: 15%;
              ">VOTOS EMITIDOS EN LA SOLICITUD</span>
          </mdb-row>
          <mdb-row class="mt-5">
            <mdb-col :md="loginUserType == 'PARTNER_SERVICE' ? 6 : 5">
              <span style="
                  text-align: center;
                  font-size: 21px;
                  font-weight: 600;
                  color: #dc7134;
                ">Usuario del Comité</span>
            </mdb-col>

            <mdb-col md="4">
              <span style="
                  text-align: center;
                  font-size: 21px;
                  font-weight: 600;
                  color: #dc7134;
                ">¿Ha emitido su voto?</span>
            </mdb-col>

            <!-- <mdb-col md="2" v-if="loginUserType!='PARTNER_SERVICE'">
              <span
                style="
                  text-align: center;
                  font-size: 21px;
                  font-weight: 600;
                  color: #dc7134;
                "
                >Voto</span
              >
            </mdb-col> -->

            <mdb-col md="3">
              <span style="
                  text-align: center;
                  font-size: 21px;
                  font-weight: 600;
                  color: #dc7134;
                ">Fecha</span>
            </mdb-col>
          </mdb-row>
          <mdb-row v-for="(item, index) in votosComite" :key="index + ' ' + item.username" class="mt-3">
            <mdb-col :md="loginUserType == 'PARTNER_SERVICE' ? 6 : 5">
              <span style="font-size: 18px; font-weight: 500">
                {{ item.username }}
              </span>
            </mdb-col>

            <mdb-col v-if="item.committeeVote != null" md="4">
              <span style="font-size: 18px; font-weight: 500; color: #285f46">
                Si
              </span>
            </mdb-col>
            <mdb-col v-else md="4">
              <span style="font-size: 18px; font-weight: 500; color: #d65050">
                No
              </span>
            </mdb-col>

            <!-- <mdb-col md="2" v-if="loginUserType!='PARTNER_SERVICE'">
              <span style="font-size: 18px; font-weight: 500">
                {{
                  item.committeeVote == "ACCEPTED"
                    ? "Aceptada"
                    : item.committeeVote == "DECLINED"
                    ? "Declinado"
                    : "Sin emitir"
                }}
              </span>
            </mdb-col> -->

            <mdb-col v-if="item.createdAt != null" md="3">
              <span style="font-size: 18px; font-weight: 500">
                {{ item.createdAt.split(" ")[0] }}
              </span>
            </mdb-col>
            <mdb-col v-else md="3">
              <span style="font-size: 18px; font-weight: 500"> ----- </span>
            </mdb-col>
          </mdb-row>
          <mdb-row v-for="(item, index) in votosComite" :key="index + '/' + item.username">
            <mdb-col v-if="item.committeeVote != null && item.username == username" class="mt-5" md="12">
              <span style="font-size: 20px; font-weight: 500">
                Ya emitiste el voto para esta solicitud
              </span>
            </mdb-col>
            <mdb-col v-else-if="
              item.committeeVote == null && item.username == username
            " class="mt-5" md="12">
              <span style="font-size: 20px; font-weight: 500">
                Aún no realizas tu voto para esta solicitud
              </span>
            </mdb-col>
          </mdb-row>
        </mdb-col>
      </div>
    </Popup>

    <Popup size="sm" ref="statusHistorial" :title="'Historial de Estatus'">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <table class="table-status">
              <thead>
                <tr>
                  <th>Estatus</th>
                  <th width="120px">Fecha</th>
                  <th width="60px" class="text-center">Días</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in statusHistory" :key="item.status">
                  <td>{{ item.status }}</td>
                  <td>{{ item.setAt }}</td>
                  <td class="text-right">{{ item.days }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" style="color: #dc7134; font-size: 1.8em">
                    <b>Total de días</b>
                  </td>
                  <td class="text-right">
                    <b>{{ totalHistoryDays }}</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Loader v-show="isLoading" />
  </div>
</template>

<script>
import Vue from "vue";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCardBody,
  mdbCard,
  mdbTooltip,
  mdbPopover
} from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import Btn from "../../core/Button";
import Popup from "../../core/Popup";
import PopupApp from "../../core/PopupApplication";
import Swal from "sweetalert2";
import { required, email } from "vuelidate/lib/validators";
import ValidationError from "../misc/ValidationError";
import App from "./Application";
import AppUp from "./ApplicationUpload";
import moment from "moment";
import Loader from "../../core/Loader";
import Accordion from "../../core/Accordion";
import AccordionAdmin from "../../core/AccordionAdmin";
import AccordionHeader from "../../core/Accordion/Header";
import Paginator from "../../core/Paginator.vue"
export default {
  name: "Applications",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCardBody,
    mdbCard,
    mdbTooltip,
    mdbPopover,
    Btn,
    Popup,
    PopupApp,
    ValidationError,
    App,
    AppUp,
    Loader,
    Accordion,
    AccordionAdmin,
    AccordionHeader,
    Paginator
  },
  data() {
    return {
      columns: [
        {
          label: 'No. de solicitud',
          key: 'applicationNumber',
          sort: false,
          class: 'text-center',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 0.5rem",
            "background-color": "#3a8a65",
            "color": "#fff",
            "border-top-left-radius": "5px",
            "border-bottom-left-radius": "5px"
          },
          tdClass: "tableCol-start",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Estatus',
          key: 'applicationStatus',
          sort: false,
          class: 'text-left',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 0.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Nombre',
          key: 'name',
          sort: false,
          class: 'text-left',
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 0.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Fecha de creación', key: 'date', sort: false, class: 'text-center', thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 2.5rem",
            "background-color": "#3a8a65",
            "color": "#fff"
          },
          tdClass: "tableCol",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
        {
          label: 'Opciones',
          key: 'options',
          sort: false,
          thStyle: {
            "font-size": "1.6rem",
            "padding": "1.0rem 2.5rem",
            "background-color": "#3a8a65",
            "color": "#fff",
            "border-top-right-radius": "5px",
            "border-bottom-right-radius": "5px"
          },
          tdClass: "tableCol-end",
          tdStyle: {
            "font-size": "1.6rem",
          }
        },
      ],
      perPage: 10,

      eventHub: new Vue(),
      totalOfElements: 0,
      page: 1,
      pages: [],
      numberOfPages: 0,
      search: "",
      search2: "",
      dataList: [],
      showFilterApp: false,
      indexPop: 1,
      checkedApp: [],
      watchButton: "watch-unpressed-btn.svg",
      uuid: "",
      commentToCommite: "",
      votesDone: 0,
      votesDeclined: 0,
      statusFinal: "",
      openApp: false,
      isLoading: false,
      statusFilter: "",
      notesTitle: "",
      notesApp: "",
      LIST_STATUS_TRANSLATE: {
        CREATED: "CREADA",
        IN_RESEARCH: "EN INVESTIGACIÓN",
        RESEARCH_FINISHED: "LISTA PARA REVISIÓN",
        IN_REVIEW_BY_PARTNER_SERVICE: "EN REVISIÓN POR ATENCIÓN A SOCIOS",
        IN_REVIEW_BY_COMMITTEE: "EN REVISIÓN POR COMITÉ",
        ACCEPTED: "ACEPTADA",
        DECLINED: "RECHAZADA",
        FINISHED: "FINALIZADA",
      },
      LIST_STATUS: null,
      application: {
        application: { applicationNumber: "", createdAt: "" },
        createdAt: "",
        beneficieries: [],
        documents: [{ value: "" }, { value: "" }, { value: "" }],
        user: { username: "" },
        name: "",
        lastName: "",
        motherLastName: "",
        birthDate: "",
        birthPlace: "",
        investigationResultMessage: null,
        investigations: [],
        phones: [],
        recommendations: [
          {
            cellPhone: "",
            createdAt: "",
            deedNumber: null,
            email: "",
            partnerLastName: "",
            partnerMothersLastName: "",
            partnerName: "",
          },
        ],
        laborData: null,
        flagChange: false,
      },
      votosComite: [
        {
          username: "",
          createdAt: "",
          committeeVote: null,
        },
      ],

      statusHistory: [],
      totalHistoryDays: 0,
    };
  },
  methods: {
    ...mapActions([
      "getListOfApplications",
      "getSingleApplication",
      "setAppInRevision",
      "setAppInComite",
      "emitirVoto",
      "sendEmailtoApplicant",
      "obtainAddress",
      "obtainAddressBeneficiaries",
      "obtainAddressBill",
      "getListOfStatus",
      "saveNotes",
      "sendReminderComite",
      "getStatusHistory",
    ]),
    getStatusClass(status) {
      switch (status) {
        case 'IN_REVIEW_BY_PARTNER_SERVICE':
          return 'dot_review_partner'
        case 'IN_RESEARCH':
          return 'dot_reserch_f'
        case 'RESEARCH_FINISHED':
          return 'dot_reserch_f'
        case 'ACCEPTED':
          return 'dot_accepted'
        case 'DECLINED':
          return 'dot_declined'
        case 'CREATED':
          return 'dot_created'
        case 'FINISHED':
          return 'dot_finished'
        case 'IN_EDIT_BY_PARTNER_SERVICE':
          return 'dot_edit1'
        case 'IN_EDIT_ACCEPTED':
          return 'dot_edit2'
        case 'DOCUMENTATION_FINISHED':
          return 'dot_documentation_finished'
        case 'IN_REVIEW_BY_COMMITTEE':
          return 'dot_review_committe'
        default:
          return ''
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'IN_REVIEW_BY_PARTNER_SERVICE':
          return 'EN REVISIÓN POR ATENCIÓN A SOCIOS';
        case 'IN_RESEARCH':
          return 'EN INVESTIGACIÓN'
        case 'RESEARCH_FINISHED':
          return 'LISTA PARA REVISIÓN'
        case 'ACCEPTED':
          return 'ACEPTADA'
        case 'DECLINED':
          return 'DECLINADA'
        case 'CREATED':
          return 'CREADA'
        case 'FINISHED':
          return 'FINALIZADA'
        case 'IN_EDIT_BY_PARTNER_SERVICE':
          return 'EN CORRECCIÓN POR EL SOLICITANTE'
        case 'IN_EDIT_ACCEPTED':
          return 'ACEPTADA PERO REQUIERE CORRECIONES'
        case 'DOCUMENTATION_FINISHED':
          return 'DOCUMENTACIÓN FINALIZADA'
        case 'IN_REVIEW_BY_COMMITTEE':
          return 'EN REVISIÓN POR COMITÉ'
        default:
          return 'DESCONOCIDO'
      }
    },
    changePage(value) {
      this.page = value
    },
    changePerPage(value) {
      this.perPage = value
    },
    checkVotes(votes) {
      let aux = this.username;
      let vote = votes.filter(function (item) {
        return item.username == aux;
      });
      if (vote.length > 0) {
        if (vote[0].committeeVote != null) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async resendToCommite(id) {
      this.$refs.resendToCommite.toggleModal();
      this.isLoading = true;
      let data = {
        id: this.checkedApp[0].id,
      };
      try {
        let response = await this.sendReminderComite(data);
        this.isLoading = false;
        if (response.data.status == 200)
          this.registerDone("Recordatorio enviado correctamente");
      } catch (error) {
        this.isLoading = false;
        alert("HA OCURRIDO UN ERROR");
      }
    },
    async openNotes(appCode, appName, appLastName, appMotherLastName, uuid) {
      this.notesTitle =
        appCode + ": " + appName + " " + appLastName + " " + appMotherLastName;
      this.notesApp = "";
      let response = await this.getSingleApplication(uuid);
      this.application = response.data.data;
      this.notesApp = this.application.application.notes;
      this.flagChange = false;
      this.$refs.notes.toggleModal();
    },
    async closeNotes() {
      if (this.notesApp != "") {
        let data = {
          id: this.application.application.id,
          body: {
            notes: this.notesApp,
          },
        };
        let response = await this.saveNotes(data);
        if (response.data.status == 200) {
          this.notesTitle = "";
          this.notesApp = "";

          this.registerDone("Tus notas han sido guardadas correctamente");
        }
        this.$refs.notes.toggleModal();
      } else {
        Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>Las notas no pueden quedar vacías, ingresa tus comentarios.</p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",
          allowOutsideClick: false,
          width: "50rem",
          padding: "2rem",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc7134",
          customClass: {
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          onClose: () => { },
        });
      }
    },
    async sendEmail() {
      let data = {
        id: this.checkedApp[0].id,
      };
      try {
        let response = await this.sendEmailtoApplicant(data);
        if (response.data.status == 200) {
          this.sendDone();
        }
      } catch (error) {
        this.$refs.sendToApp.toggleModal();
        Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>Ya has enviado un correo de respuesta al solicitante, no es posible enviarlo nuevamente.</p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",
          allowOutsideClick: false,
          width: "50rem",
          padding: "2rem",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc7134",
          customClass: {
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          onClose: () => { },
        });
      }
    },
    async vote(voteState) {
      let data = {
        id: this.checkedApp[0].id,
        vote: voteState,
      };
      try {
        let response = await this.emitirVoto(data);
        if (response.data.status == 200) {
          if (voteState == "ACCEPTED") {
            this.voteDone();
          } else {
            this.voteDecline();
          }
        }
      } catch (error) {
        if (voteState == "ACCEPTED") {
          this.$refs.accept.toggleModal();
        } else {
          this.$refs.decline.toggleModal();
        }

        Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>Ya has emitido tu voto por esta solicitud, no es posible votar nuevamente.</p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",
          allowOutsideClick: false,
          width: "50rem",
          padding: "2rem",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc7134",
          customClass: {
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          onClose: () => { },
        });
      }
    },
    async viewDictamen(uuid) {
      let response = await this.getSingleApplication(uuid);

      let contVotes = response.data.data.application.votesCast.filter(function (
        vote
      ) {
        return vote.committeeVote == "ACCEPTED";
      });
      (this.votesDone = contVotes.length),
        (contVotes = response.data.data.application.votesCast.filter(function (
          vote
        ) {
          return vote.committeeVote == "DECLINED";
        }));
      this.votesDeclined = contVotes.length;

      if (response.data.data.application.applicationStatus == "ACCEPTED") {
        this.statusFinal = "ACEPTADA";
      }
      if (response.data.data.application.applicationStatus == "DECLINED") {
        this.statusFinal = "DECLINADA";
      }
      this.$refs.dictamen.toggleModal();
    },
    async sendToRevision() {
      let response = await this.setAppInRevision(this.checkedApp[0]);
      if (response.data.status == 200) {
        this.$refs.toPartner.toggleModal();
        this.registerDone("LA SOLICITUD SE HA COLOCADO EN REVISIÓN");
      } else {
        alert("HA OCURRIDO UN ERROR");
      }
    },

    async openStatusHistory(id) {
      this.isLoading = true;
      this.totalHistoryDays = 0;
      this.statusHistory = [];
      try {
        const { data } = await this.getStatusHistory(id);
        //console.log(data);
        this.statusHistory = data;
        this.statusHistory.forEach((element) => {
          //console.log(element)
          this.totalHistoryDays += element.days;
        });
        this.$refs.statusHistorial.toggleModal();
      } catch (e) {
        //console.log(e)
      } finally {
        this.isLoading = false;
      }
    },

    async getApplicationsList() {
      let params = {};
      params.clubCode = "CGTM";
      params.pageNumber = this.page - 1;
      params.pageSize = this.perPage;
      params.search = this.statusFilter == "" ? this.search : this.search2;
      try {
        this.isLoading = true;
        const { data } = await this.getListOfApplications(params);
        this.isLoading = false;
        if (data != null) {
          const { data: applications, totalElements, totalPages } = data;
          this.numberOfPages = totalPages;
          this.totalOfElements = totalElements;
          this.dataList = applications.sort(function (a, b) {
            var dateAux = a.createdAt.split(" ")[0];
            let dateA = new Date(
              dateAux.split("-")[1] +
              "/" +
              dateAux.split("-")[0] +
              "/" +
              dateAux.split("-")[2]
            );
            var dateAux2 = b.createdAt.split(" ")[0];
            let dateB = new Date(
              dateAux2.split("-")[1] +
              "/" +
              dateAux2.split("-")[0] +
              "/" +
              dateAux2.split("-")[2]
            );

            if (dateA < dateB) {
              return 1;
            }
            if (dateA > dateB) {
              return -1;
            }
            return 0;
          });
        } else {
          this.dataList = [];
          this.totalOfElements = 0;
        }
      } catch (error) {
        this.isLoading = false;
        this.dataList = [];
        this.totalOfElements = 0;
      }
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      this.totalOfElements = wList.length;
      aux.numberOfPages = Math.ceil(wList.length / this.perPage);
      wList = wList.sort(function (a, b) {
        var dateAux = a.createdAt.split(" ")[0];
        dateAux.split("-")[0];
        dateAux.split("-")[1];
        dateAux.split("-")[2];

        let dateA = new Date(
          dateAux.split("-")[1] +
          "/" +
          dateAux.split("-")[0] +
          "/" +
          dateAux.split("-")[2]
        );

        var dateAux2 = b.createdAt.split(" ")[0];
        dateAux2.split("-")[0];
        dateAux2.split("-")[1];
        dateAux2.split("-")[2];

        let dateB = new Date(
          dateAux2.split("-")[1] +
          "/" +
          dateAux2.split("-")[0] +
          "/" +
          dateAux2.split("-")[2]
        );

        if (dateA < dateB) {
          return 1;
        }
        if (dateA > dateB) {
          return -1;
        }
        return 0;
      });
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    cleanDataTable() {
      this.totalOfElements = 0;
      this.page = 1;
      this.perPage = 10;
      this.pages = [];
      this.numberOfPages = 0;
      this.search = "";
      this.dataList = [];
      this.uuid = "";
    },
    async viewListDocuments(uuid, status) {
      this.uuid = uuid;
      let response = await this.getSingleApplication(uuid);
      this.application = response.data.data;
      this.$refs.uploadDocumentation.toggleModal();
    },
    async getOneApplication(uuid, status) {
      this.uuid = uuid;
      let response = await this.getSingleApplication(uuid);
      this.application = response.data.data;

      if (status != "CREATED") {
        if (this.application.address != null) {
          await this.obtainAddress(this.application.address.location.id);

          if (this.application.billingInformation) {
            await this.obtainAddressBill(
              this.application.billingInformation.address.location.id
            );
          }

          let addressBenef = [];
          let addressSpose = [];
          for (
            let index = 0;
            index < this.application.beneficiaries.length;
            index++
          ) {
            let benef = this.application.beneficiaries[index];

            //console.log(benef);
            ////AQUI DEBO DE FILTRAR A LA ESPOSA

            if (benef.address != null) {
              let response = await this.obtainAddressBeneficiaries(
                benef.address.location.id
              );

              let aux = {};
              aux.state = response.state;
              aux.city = response.city;
              aux.colony = response.colony;
              aux.zipCode = response.zipCode;
              if (benef.beneficiaryType == "SPOUSE") {
                addressSpose.push(aux);
              } else {
                addressBenef.push(aux);
              }
            }
          }
          this.$store.commit("setAddressBenef", addressBenef);
          this.$store.commit("setSpouseAddress", addressSpose);
        }
        this.$refs.solicitud.toggleModal();
      } else {
        this.$refs.solicitudCreada.toggleModal();
      }
    },
    getCurpValue(documentArray) {
      let val = documentArray.filter(function (item) {
        return item.documentType == "CURP";
      });
      if (val.length > 0) {
        return val[0].value;
      }
      return val;
    },
    registerDone(text) {
      Swal.fire({
        title:
          " <span style=' font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>" +
          text +
          "</span>",
        html:
          "<div>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "Ok",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        onClose: () => {
          this.checkedApp = [];
          this.cleanDataTable();
          this.getApplicationsList();
        },
      });
    },
    voteDone() {
      this.$refs.accept.toggleModal();
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>VOTACIÓN EMITIDA</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 12px; font-family: Open Sans' color: #828282'>" +
          "<p>Tu votación se guardó a favor de <strong>ACEPTAR</strong> la solicitud.</p><p><strong>Espera el resultado de dictamen.</strong></p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAceptado.svg' alt='aceptado'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "OK",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        onClose: () => {
          this.checkedApp = [];
          this.cleanDataTable();
          this.getApplicationsList();
        },
      });
    },
    voteDecline() {
      this.$refs.decline.toggleModal();
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>VOTACIÓN EMITIDA</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 12px; font-family: Open Sans' color: #828282'>" +
          "<p>Tu votación se guardó a favor de <strong>DECLINAR</strong> la solicitud.</p><p><strong>Espera el resultado de dictamen.</strong></p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoDeclinado.svg' alt='aceptado'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "OK",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        onClose: () => {
          this.checkedApp = [];
          this.cleanDataTable();
          this.getApplicationsList();
        },
      });
    },
    sendDone() {
      this.$refs.sendToApp.toggleModal();
      Swal.fire({
        title:
          " <span style=' font-size: 22px; font-weight: 600; color: #dc7134; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>¡CORREO ENVÍADO CORRECTAMENTE!</span>",
        html:
          "<div>" +
          "<img src='/img/icons/email-sent.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "Ok",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        onClose: () => {
          this.checkedApp = [];
          this.cleanDataTable();
          this.getApplicationsList();
        },
      });
    },
    maxCharCount() {
      if (this.notesApp && this.notesApp.length == 3000 && this.flagChange) {
        Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>No es posible añadir más texto, se ha superado el límite.</p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",
          allowOutsideClick: false,
          width: "50rem",
          padding: "2rem",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc7134",
          customClass: {
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          onClose: () => { },
        });
      }
      return (
        3000 -
        (this.notesApp != null ? this.notesApp.length : 0) +
        " / " +
        3000 +
        " Caracteres"
      );
    },
  },
  async mounted() {
    this.cleanDataTable();
    this.getApplicationsList();
    this.LIST_STATUS = await this.getListOfStatus();
  },
  watch: {
    notesApp() {
      if (this.notesApp && this.notesApp.length < 3000) {
        this.flagChange = true;
      }
    },
    search() {
      this.page = 1;
      this.getApplicationsList();
    },
    page() {
      this.getApplicationsList();
    },
    perPage() {
      this.getApplicationsList();
    },
    statusFilter(val) {
      if (val != "") {
        this.search = this.LIST_STATUS_TRANSLATE[val];
        this.search2 = val;
      } else {
        this.search = "";
      }
      if (this.showFilterApp) this.showFilterApp = false;
    },
  },
  computed: {
    ...mapGetters({
      loginUserType: "getUserType",
      username: "getUserName",
      app: "getApp",
    }),
    appStatus() {
      try {
        if (this.checkedApp[0].status == "ACCEPTED") return "ACEPTADA";
        if (this.checkedApp[0].status == "DECLINED") return "DENEGADA";
        else {
          return "APP STATUS";
        }
      } catch (e) {
        return "APP STATUS";
      }
    },
    // charCount() {
    //   if (this.notesApp && this.notesApp.length == 3000 && this.flagChange) {
    //     Swal.fire({
    //       title:
    //         "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",
    //       html:
    //         "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
    //         "<p>No es posible añadir más texto, se ha superado el límite.</p>" +
    //         "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
    //         "</div>",
    //       allowOutsideClick: false,
    //       width: "50rem",
    //       padding: "2rem",
    //       confirmButtonText: "Ok",
    //       confirmButtonColor: "#dc7134",
    //       customClass: {
    //         confirmButton: "t1-btn t1-btn--primary-block",
    //       },
    //       onClose: () => {},
    //     });
    //   }
    //   return (
    //     3000 -
    //     (this.notesApp != null ? this.notesApp.length : 0) +
    //     " / " +
    //     3000 +
    //     " Caracteres"
    //   );
    // },
  },
};
</script>

<style>
.tableCol {
  background-color: #fff;
  color: #000;
  font-size: 1.6rem;
}

.tableCol-start {
  background-color: #fff;
  color: #000;
  font-size: 1.6rem;
}

.tableCol-end {
  background-color: #fff;
  color: #000;
  font-size: 1.6rem;
}

.t1-checkbox label {
  color: #000 !important;
}

.btn-notas {
  background: url("/img/notes.png") center no-repeat;
  background-size: 5px 5px;
  background-color: transparent;
}

textarea {
  resize: none;
}

.committeeVotes {
  font-weight: 550;
  text-decoration: underline;
  cursor: pointer;
}

.committeeVotes:hover {
  color: rgb(44, 87, 119);
}

.committeeVotes:active {
  color: #dc7134;
}

table.table-status {
  width: 100%;
}

table.table-status th {
  color: #dc7134;
  font-size: 1.8em;
}

table.table-status td {
  font-size: 1.6em;
}

.solicitudes__fix-style-button{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.card-div.solicitudes__card-div{
  margin-bottom: 0;
  margin-top: 0;
  padding-bottom: 3rem;
}
@media (min-width: 1450px) {
  textarea.form-control {
    height: 80vh;
  }

  .popup__content.popup__content--sm-mod2 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}

@media (min-width: 1024px) and (max-width: 1449px) {
  textarea.form-control {
    height: 75vh;
  }

  .popup__content.popup__content--sm-mod2 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table td {
    padding: 0.25rem;
  }

  .tableCol-start {
    padding-left: 30px !important;
    padding-right: 10px !important;
  }

}


@media (max-width: 768px) {
  .popup {
    height: 120vh;
  }
}

@media (max-width: 425px) {
  .popup {
    height: 160vh;
  }
}

@media (max-width: 375px) {
  .popup {
    height: 180vh;
  }
}

@media (max-width: 320px) {
  .popup {
    height: 220vh;
  }
}
</style>
